export default "__VITE_ASSET__460d72e2__"